export enum EAdminTab {
    USERS = 'USERS',
    USERSNEW = 'USERSNEW',
    ORGANIZATIONS = 'ORGANIZATIONS',
    INVITATIONS = 'INVITATIONS',
    GROUPS = 'GROUPS',
    REFERENTIALS = 'REFERENTIALS',
    TRANSLATIONS = 'TRANSLATIONS',
    USEFULLINKS = 'USEFULLINKS',
    WORKSPACEINVITATION = 'WORKSPACEINVITATION',
    CONFIGURATION = 'CONFIGURATION'
}

export const ADMIN_TAB_DEFAULT_MESSAGES: Partial<Record<EAdminTab, string>> = {
    [EAdminTab.USERSNEW]: 'Users new',
    [EAdminTab.CONFIGURATION]: 'Configuration'
};

export const isSuperAdminOnlyTab = (tab: string) =>
    tab === EAdminTab.USERSNEW
    || tab === EAdminTab.WORKSPACEINVITATION
    || tab === EAdminTab.CONFIGURATION;
